<template>
  <div
    class="section-main-container mb-8"
    :style="{ height: isExpanded ? 'auto' : 'auto' }"
    data-aos="fade-up"
  >
    <v-row>
      <v-col
        cols="12"
        :xs="12"
        :sm="12"
        :md="3"
        :lg="3"
      >
        <div class="section-img">
          <img :src="imageUrl" alt="logo image" class="img-fluid">
        </div>
      </v-col>
      <v-col
        cols="12"
        :xs="12"
        :sm="12"
        :md="9"
        :lg="9"
      >
        <div class="section-heading">
          <h3>{{ heading }}</h3>
          <div v-if="isExpanded && !content.redirectTo" class="content">
           <b><p v-html="content.heading"></p></b>
            <p>{{ content.text1 }}</p><br>
            <p>{{ content.text2 }}</p>
            <!-- <p>{{ content.text3 }}</p> -->
            <p v-html="content.text3"></p> <!-- Render HTML -->
          </div>
          <v-btn elevation="0" class="mt-5" @click="toggleExpanded" v-if="!content.redirectTo">
            {{ isExpanded ? 'Read Less' : 'Read More' }}
          </v-btn>
          <v-btn elevation="0" class="mt-5" @click="redirect" v-if="content.redirectTo">
            Read More
          </v-btn>

        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import { useRouter } from 'vue-router';

interface Content {
  heading?: string;
  text1?: string;
  text2?: string;
  text3?: string;
  redirectTo?: string;
}


export default defineComponent({
  props: {
    imageUrl: String,
    heading: String,
    content: Object as () => Content 
  },
  setup(props) {
    const isExpanded = ref(false);
    const router = useRouter();

    const toggleExpanded = () => {
      isExpanded.value = !isExpanded.value;
    };

    const redirect = () => {
      if (props.content?.redirectTo) {
        router.push(props.content.redirectTo).then(() => {
          window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        });

      }
    };

    return { isExpanded, toggleExpanded, redirect };
  }
});
</script>

<style scoped>
.section-main-container{
  background-color: #fff;
  padding: 40px;
  transition: height 0.5s; /* Adding transition for smooth height change */
}
.section-main-container img {
  height: auto;
}
.section-heading{
  margin-left: 16px;
  width: 80%;
}
.section-heading h3{
  font-size: 25px;
  font-weight: 400;
}
.section-heading button{
  border: 1px solid;
  border-radius: 50px;
  font-size: 11px;
  width: 103px;
  height: 34px;
  font-weight: 600;
}
.section-heading button:hover{
  color: #fff;
  background-color: black
}
.section-img{
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
  object-fit: contain;

}
.img-fluid{
  max-width: 100%;
  max-height: 150px;
  height: auto;
  display: block;
}
.content p {
  margin: 10px 0;
}
.content a {
  color:blue; 
}
@media (max-width: 960px) {
  .section-heading{
    width: 100%;
    display: ruby-text;
    margin-left: 0px;
  }
  .section-heading h3{
    text-align: center;
    font-size: 21px;
  }
  .section-main-container{
    padding: 30px;
  }
}
@media (max-width: 750px) {
  .section-heading h3{
    text-align: center;
    font-size: 19px;
  }
  .section-main-container{
    padding: 25px;
  }
}
@media (max-width: 650px) {
  .section-heading h3{
    text-align: center;
    font-size: 16px;
  }
  .section-main-container{
    padding: 20px;
  }
}

</style>
